// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Mixins **/
/** Vars (common) **/
/** app colors **/
/** Vars (MuiAlert) **/
/** main classes **/
.nibCardCheckList_old-container__ency\\+ {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.nibCardCheckList_old-container__ency\\+.nibCardCheckList_wrap__nVCiX {
  flex-wrap: wrap;
}
.nibCardCheckList_old-container__ency\\+ .nibCardCheckList_box__o2BM7.nibCardCheckList_col__fNo4U {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
}
.nibCardCheckList_old-container__ency\\+ .nibCardCheckList_box__o2BM7.nibCardCheckList_col__fNo4U > div {
  width: 100%;
}
.nibCardCheckList_old-container__ency\\+ .nibCardCheckList_box__o2BM7.nibCardCheckList_row__mUU6Q {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.nibCardCheckList_old-container__ency\\+ form {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
}
.nibCardCheckList_old-container__ency\\+ form > .nibCardCheckList_box__o2BM7.nibCardCheckList_col__fNo4U {
  flex-basis: 33.33%;
}
@media screen and (min-width: 2560px) {
  .nibCardCheckList_old-container__ency\\+ form > .nibCardCheckList_box__o2BM7.nibCardCheckList_col__fNo4U {
    flex-basis: 0%;
    margin-right: 2em;
  }
}

@media screen and (max-width: 580px) {
  .nibCardCheckList_old-container__ency\\+, .nibCardCheckList_col__fNo4U, form {
    padding: 5px;
  }
}
@media screen and (max-width: 450px) {
  .nibCardCheckList_old-container__ency\\+, .nibCardCheckList_col__fNo4U, form {
    padding: 0px;
  }
}
.nibCardCheckList_text-overflow-hidden__Dhs3R {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nibCardCheckList_icon__pHcUB {
  color: var(--accent-color);
}

.nibCardCheckList_richtext-output-wrap__prU8R .nibCardCheckList_se-video-container__GcSPQ figure {
  padding-bottom: 0 !important;
}

.nibCardCheckList_list__dz6qd {
  background-color: #212121;
  border-radius: 10px;
  overflow: auto;
}

.nibCardCheckList_labels__2RJza {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px 15px;
  background-color: #2A2A2A;
}
.nibCardCheckList_labels__2RJza p {
  color: #fff;
}

.nibCardCheckList_labelTitle__TuGT5 {
  font-size: 18px;
}

.nibCardCheckList_inner__IQ3Gv {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.nibCardCheckList_inner__IQ3Gv .nibCardCheckList_label__23laG {
  flex-basis: 50%;
  color: #fff;
}
.nibCardCheckList_inner__IQ3Gv .nibCardCheckList_underlabel__F1ns\\+ {
  font-size: 13px;
  color: #cecece;
}
.nibCardCheckList_inner__IQ3Gv .nibCardCheckList_checkBox__\\+7Jee {
  flex-basis: 25%;
  padding-right: 4px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/sass/_settings.sass","webpack://./src/components/common/NibCard/NibCardCheckList/nibCardCheckList.module.sass"],"names":[],"mappings":"AAAA,aAAA;AAeA,oBAAA;AAgBA,iBAAA;AA0BA,sBAAA;AAGA,mBAAA;AACA;EA3DE,aAAA;EACA,mBA4DM;EA3DN,8BA2DW;EA1DX,uBA0D0B;EAC1B,kBAAA;EACA,WAAA;ACrDF;ADsDE;EACE,eAAA;ACpDJ;ADsDI;EAnEF,aAAA;EACA,sBAmEU;EAlEV,2BAkEkB;EAjElB,uBAiE8B;EAC1B,eAAA;ACjDN;ADkDM;EACE,WAAA;AChDR;ADiDI;EAxEF,aAAA;EACA,mBAwEU;EAvEV,2BAuEe;EAtEf,uBAsE2B;EACvB,WAAA;AC5CN;AD6CE;EACE,aAjDK;EA3BP,aAAA;EACA,mBA4EQ;EA3ER,2BA2Ea;EA1Eb,uBA0EyB;EACvB,kBAAA;EACA,eAAA;EACA,WAAA;ACxCJ;ADyCI;EACE,kBAAA;ACvCN;ADwCM;EAFF;IAGI,cAAA;IACA,iBAAA;ECrCN;AACF;;ADsCA;EAEE;IACE,YAFO;EClCT;AACF;ADoCA;EAEE;IACE,YAFO;ECjCT;AACF;ADoCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AClCF;;ADoCA;EACE,0BAtFO;ACqDT;;ADqCI;EACE,4BAAA;AClCN;;AAzEA;EACE,yBDyBgC;ECxBhC,mBAAA;EACA,cAAA;AA4EF;;AA1EA;EDLE,aAAA;EACA,mBCKM;EDJN,8BCIW;EDHX,mBCG0B;EAC1B,iBAAA;EACA,yBAAA;AAgFF;AA/EE;EACE,WAAA;AAiFJ;;AA/EA;EACE,eAAA;AAkFF;;AAhFA;EACE,WAAA;EDhBA,aAAA;EACA,mBCgBM;EDfN,8BCeW;EDdX,mBCc0B;AAsF5B;AArFE;EACE,eAAA;EACA,WAAA;AAuFJ;AAtFE;EACE,eAAA;EACA,cDDG;ACyFP;AAvFE;EACE,eAAA;EACA,kBAAA;ED1BF,aAAA;EACA,mBC0BQ;EDzBR,yBCyBa;EDxBb,mBCwBuB;AA4FzB","sourcesContent":["/** Mixins **/\n=flex($der, $justy, $align)\n  display: flex\n  flex-direction: $der\n  justify-content: $justy\n  align-items: $align\n\n=shadow()\n  box-shadow: -5px 5px 10px 0px rgba(#000, .35)\n\n=staticHeight($height)\n  min-height: $height\n  max-height: $height\n  height: $height\n\n/** Vars (common) **/\n$main: #2F2F2F\n$main_background: #191818\n$accent: var(--accent-color)\n$accent_text: var(--accent-text-color)\n$accent_r: var(--accent-color-r)\n$accent_g: var(--accent-color-g)\n$accent_g10: var(--accent-color-g10)\n$accent_b: var(--accent-color-b)\n$text: #cecece\n$error: #f44336\n$success: rgb(102, 187, 106)\n$container_background_color: #1B1B1B\n$container_item_background_color: #212121\n$gutter: 20px\n\n/** app colors **/\n$soft_teal: #84aaaf\n$fiery_red: #ff3131\n$muted_red: #e85a4f\n$app_red: #B83336\n$soft_creamy: #f5e8dd\n$light_gray: #535353\n$golden_yellow: #ffc107\n$orange: #ffa725\n$app_orange: #DB890E\n$warm_orange: #e3a869\n$faded_pink: #d69fa2\n$purple: #8868a3\n$app_purple: #7E51A3\n$light_blue: #79a8d1\n$app_green: #16962F\n$retro_green: #4a7c59\n$deep_blue: #406ca8\n\n$main_block_top_padding: 130px\n$main_block_top_padding_s: 70px\n$header_height: 120px\n$sidebar_width: 320px\n\n$table_row_height: 55px\n\n/** Vars (MuiAlert) **/\n$MuiAlert_main_color: rgb(166, 213, 250)\n\n/** main classes **/\n.old-container\n  //padding: $gutter\n  +flex(row, space-between, flex-start)\n  position: relative\n  width: 100%\n  &.wrap\n    flex-wrap: wrap\n  .box\n    &.col\n      +flex(column, flex-start, flex-start)\n      padding: 0 calc($gutter/2)\n      > div\n        width: 100%\n    &.row\n      +flex(row, flex-start, flex-start)\n      width: 100%\n  form\n    padding: $gutter\n    +flex(row, flex-start, flex-start)\n    position: relative\n    flex-wrap: wrap\n    width: 100%\n    > .box.col\n      flex-basis: 33.33%\n      @media screen and ( min-width: 2560px )\n        flex-basis: 0%\n        margin-right: 2em\n\n@media screen and ( max-width: 580px )\n  $gutter: 5px\n  .old-container, .col, form\n    padding: $gutter\n@media screen and ( max-width: 450px )\n  $gutter: 0px\n  .old-container, .col, form\n    padding: $gutter\n\n.text-overflow-hidden\n  overflow: hidden\n  text-overflow: ellipsis\n  white-space: nowrap\n\n.icon\n  color: $accent\n\n.richtext-output-wrap\n  .se-video-container\n    figure\n      padding-bottom: 0 !important\n","@import '../../../../sass/settings'\n\n.list\n  background-color: $container_item_background_color\n  border-radius: 10px\n  overflow: auto\n\n.labels\n  +flex(row, space-between, center)\n  padding: 5px 15px\n  background-color: #2A2A2A\n  p\n    color: #fff\n\n.labelTitle\n  font-size: 18px\n\n.inner\n  width: 100%\n  +flex(row, space-between, center)\n  .label\n    flex-basis: 50%\n    color: #fff\n  .underlabel\n    font-size: 13px\n    color: $text\n  .checkBox\n    flex-basis: 25%\n    padding-right: 4px\n    +flex(row, flex-end, center)"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"old-container": `nibCardCheckList_old-container__ency+`,
	"wrap": `nibCardCheckList_wrap__nVCiX`,
	"box": `nibCardCheckList_box__o2BM7`,
	"col": `nibCardCheckList_col__fNo4U`,
	"row": `nibCardCheckList_row__mUU6Q`,
	"text-overflow-hidden": `nibCardCheckList_text-overflow-hidden__Dhs3R`,
	"icon": `nibCardCheckList_icon__pHcUB`,
	"richtext-output-wrap": `nibCardCheckList_richtext-output-wrap__prU8R`,
	"se-video-container": `nibCardCheckList_se-video-container__GcSPQ`,
	"list": `nibCardCheckList_list__dz6qd`,
	"labels": `nibCardCheckList_labels__2RJza`,
	"labelTitle": `nibCardCheckList_labelTitle__TuGT5`,
	"inner": `nibCardCheckList_inner__IQ3Gv`,
	"label": `nibCardCheckList_label__23laG`,
	"underlabel": `nibCardCheckList_underlabel__F1ns+`,
	"checkBox": `nibCardCheckList_checkBox__+7Jee`
};
export default ___CSS_LOADER_EXPORT___;
